import Vue from 'vue';
import { models } from '@/utils/conditions.js'
import commentAnalysisApi from '@/hotelcem/apis/comment/commentAnalysis'
import CommentListService from '@/hotelcem/apis/comment/commentListService'
import TranslateService from '@/hotelcem/apis/common/TranslateService'
import { Message } from 'element-ui'
import dayjs from 'dayjs'
import { commentTreeFormatter } from '@/utils/comment/comment-functinos'
import ChannelConfig from '@/constants/channelConfig'
import AssessmentIndicatorsService from '@hotelcem/apis/configuration-center/assessmentIndicatorsService.js'

    import axios from 'axios'

    
    let _i18n_vue = new Vue();
    const $t = _i18n_vue.$t.bind(_i18n_vue);
    

let translateCancel
const state = {
  totalNumber: 0,
  hideChildMenu: undefined,
  windowInnerWidth: window?.innerWidth, // 设备宽度
  stepsList: {
    steps: 1,
    type: 'detail',
  },
  excelToken: '', // 上传之后获得token
  direction: 'answer', // 判断来源地址
  moreTableUid: [],
  createSourceData: [], // 创建数据源信息数据
  sourcePanel: {}, // 是否开启数据源面板
  dataSourceParams: {
    // 数据源/样式筛选参数
    chartConfig: {
      chartType: '', // 图表类型
      contentTypeList: [], // 显示内容类型
    },
    dataCustomModelId: '', // 自定义数据模型Id--被选中chartID--ok
    industryClassifyList: [], // 行业分类列表
    internalFilterList: [], // -图内过滤--ok
    name: '', // 数据模型名称--ok
    // parameterMap: {
    //   // ---ok
    //   // ts: { // 每个字段
    //   //   biParameterId: "ts", // Bi参数Id--
    //   //   columnId: "", // 数据源字段Id
    //   //   dataSourceId: "", // 数据源Id
    //   //   filterList: [
    //   //     // 过滤条件集合 -- ok
    //   //   ]
    //   // }
    // },
    columnConfigList: [], // 模型字段
    isEnableDrillDown: false, // 是否钻取
  },
  isSourcePanel: false,
  defaultWidth: {
    width: '523px',
    widthDate: +new Date(),
  },
  isOpen: false,
  dataSourceId: '', // 数据源Id
  saveData: {
    // 是否是保存数据
    isSaveData: false,
    saveData: {},
  },
  textAnalysisParams: {}, // 文本分析筛选
  keywordPopList: {}, // 关键字弹框数据
  changeType: 'field',
  rulesStatus: {}, // 预警规则状态
  warningDetailData: {}, // 预警详情数据
  isFieldSourceId: true, // 是否是字段上面的字段ID
  warnRulesSaveData: {}, // 预警规则保存数据
  rulessTopConditions: {
    title: '',
    isNullTitle: '', // 是否是空标题
    describe: '',
    model: 1, // 模型选择
    modelList: models,
    source: '', // 数据源
    isNullSource: '', // 数据源是否为空
    sourceList: [],
    warnRuleId: '',
    relatedId: '',
    dataSourceGroup: {},
    status: 0, // 预警规则状态
    hotelList: [], // 酒店范围
    dataType: 1,
    warnDataSource: {},
    type: '',
  },
  warnRuleTaskSave: {},
  upgradeSave: {},
  upgradeList: [],
  frequency: 0,
  isBindWechat: false, // 租户是否绑定企微

  warnMonitorPeriod: {
    period: 'day',
    input: '',
    date: '',
  }, // 监控周期
  warnRecordFilter: {},
  warnRecordInput: '',
  textRecord: {}, // 文本评价内容数据
  recordTitle: $t('f0b856'), // 评价标题
  drillDownObj: {
    value: false,
    random: '',
  },
  indicatorsLabels: [], // 被选中的指标树
  warnSaveVedioField: '', //存储语音字段
  dataModelTemplateId: '', // 记录图表的模型ID
  modelRulesDefaultData: [], // 模型规则默认数据
  isChangeRules: false,
  fieldSelectedData: [],
  fieldSelectedDimensionData: [],
  saveDimensionData: {},
  saveSourceColumns: [],
  dataSourceGroupType: {}, // 存储单个图表BI数据类型
  tenantInfo: {}, // 租户名称
  hotelcemDetail: [],
  fieldDetail: {},
  aliasConfig: {}, // 别名
  setAnalysisDims: [], // 设置分析字段
  industry: '', // 行业
  commentLabelsFilter: {},
  commentParams: {},
  commentLabelsTree: {
    loading: false,
    selectedTree: [],
  },
  commentRawData: {
    loading: false,
    rowData: [],
  },
  commentDataType: undefined,
  commentAllTransferEnglish: false,
  errorCorrection: {
    loading: false,
    opened: false,
    rowDataItem: undefined,
    tagList: [
      {
        label: $t('e0a785'),
        children: [
          // {
          //   label: '情感有误',
          // },
          // {
          //   label: '标签有误',
          // },
          {
            label: $t('2b28b4'),
          },
          {
            label: $t('dd34ed'),
          },
        ],
      },
      {
        label: $t('2c95cb'),
        children: [],
      },
      {
        label: $t('cd9bd4'),
        children: [
          {
            label: $t('b7d4ac'),
          },
          // {
          //   label: '用户追评',
          // },
          {
            label: $t('a2331b'),
          },
          {
            label: $t('cc4fee'),
          },
        ],
      },
      {
        label: $t('6b2b97'),
        children: [
          // {
          //   label: '画像不准',
          // },
          {
            label: $t('c083d1'),
          },
        ],
      },
    ],
  },

  qualityShowData: {},
  feedbackRecordDatas: [],
  commentReplyStatus: [], // 是否设置过逾期渠道
  commentRuleType: true, // 默认情感：true
  commentRuleMap: true, // 默认情感：true
  sentencesHighlight: false, // 点评管理-句片高亮
  treeSentimentLevel: '', // 指标树观点类型
  modelGlobalField: [], // 全局筛选器字段和右侧字段筛选器字段
}

const getters = {}

const actions = {
  async translateLanguage({ commit, state }, payload = {}) {
    let tableData = state.commentRawData.rowData
    let isEnglish = payload.isEnglish
    state.commentAllTransferEnglish = payload.isEnglish
    if (isEnglish) {
      if (translateCancel) {
        translateCancel({
          code: -2000,
          message: 'The user actively cancels the request',
        })
      }
      let textList = [] // 注意了。这边不是段落是语片，所以
      for (let i = 0; i < tableData.length; i++) {
        if (!tableData[i].detail.translated) {
          tableData[i].detail.bakValue = tableData[i].detail.value
          textList.push(tableData[i].detail.value)
        }
      }
      // 将txtList 尽情翻译;

      const CancelToken = axios.CancelToken
      const resContent = await TranslateService.textTranslate(
        {
          textList,
          targetLanguage: 'en',
        },
        { cancelToken: new CancelToken(e => (translateCancel = e)) }
      )
      if (!resContent?.success) {
        return
      }
      let index = 0
      for (let i = 0; i < tableData.length; i++) {
        if (!tableData[i].detail.translated) {
          tableData[i].detail.value = resContent.data[index]
          index++
          tableData[i].detail.translated = true
        }
      }
      commit('SET_COMMENT_RAW_DATA', {
        ...state.commentRawData,
        rowData: tableData,
      })
    } else {
      for (let i = 0; i < tableData.length; i++) {
        tableData[i].detail.translated = false
        if (tableData[i].detail.bakValue) {
          tableData[i].detail.value = tableData[i].detail.bakValue
        }
      }
      commit('SET_COMMENT_RAW_DATA', {
        ...state.commentRawData,
        rowData: tableData,
      })
    }
  },
  // 是否质检
  async getIsQuality({ rootState, state, commit }, payload = {}) {
    try {
      let params = {
        data: payload.map(item => {
          return {
            hotelId: item?.extraValues?.hotelId,
            otaCommentId: item?.extraValues?.commentId, //# 点评ID
            source: item?.extraValues?.channel, //# 渠道
          }
        }),
      }

      const res = await CommentListService.fetchIsQuality(params)
      if (res?.data && res?.code === 200) {
        const data = res.data
        if (data.length > 0) {
          payload.map(item => {
            const list = data.filter(subItem => subItem.otaCommentId === item?.extraValues?.commentId)
            item.isQuality = list.length > 0 ? list[0].isQuality : 0
          })
        }
      }
    } catch (error) {
      console.error(error)
    }
  },
  // 反馈记录数据
  async listFeedbackRecord({ rootState, state, commit }, payload = {}) {
    try {
      let params = {
        hotelId: payload.hotelId,
        otaCommentId: payload.commentId, //# 点评ID
        source: payload.channel, //# 渠道
      }
      const res = await CommentListService.fetchcommentQualityList(params)

      if (res?.data && res?.code === 200) {
        const data = res.data
        commit(
          'SET_FEEDBACK_RECORD_MAP',
          data.map(item => {
            return {
              feedbackTime: item.pushTime,
              feedbackReason: item.errorTypes,
              additionalInstructions: item.remark,
              processingState: item.dealStatus, // 处理中  已出理
              processingTime: item.qualityTime,
              processingResults: item.dealResult,
              processingNote: item.dealRemark,
              ...item,
            }
          })
        )
      }
    } catch (error) {
      console.error(error)
    }
  },
  // 查询点评列表
  async listCommentRawData({ rootState, state, commit, dispatch }, payload = {}) {
    try {
      if (state.commentRawData.loading) {
        return
      }
      if (translateCancel) {
        translateCancel({
          code: -2000,
          message: 'The user actively cancels the request',
        })
      }
      // 句片高亮
      const sententcesHighlightMap = localStorage.getItem('COMMENT_SENTENTCE_HIGHLIGHT')
      const sentencesHighlight = sententcesHighlightMap ? JSON.parse(sententcesHighlightMap) : false
      state.sentencesHighlight = sentencesHighlight

      // 没有酒店不请求
      // if (!state.commentParams?.ctripHotelIds || state.commentParams?.ctripHotelIds?.length === 0) {
      //   commit('SET_COMMENT_RAW_DATA', {
      //     rowData: [],
      //     pageTotal: 0,
      //   })
      //   // Message.error('没有酒店符合该组合筛选条件')
      //   return
      // }

      // if (!state.commentParams?.channels) {
      //   commit('SET_COMMENT_RAW_DATA', {
      //     rowData: [],
      //   })
      // }

      commit('SET_COMMENT_RAW_DATA', {
        loading: true,
        channelLoading: true,
      })

      const params = Object.assign({}, state.commentParams, {
        multiLabels: state.commentLabelsTree.selectedTree.filter(item => {
          return item.label_1 != $t('f9b741')
        }),
        otaCommentId: '12123456',
      })

      if (state.commentParams?.industryType) {
        params.hotelFilter = {
          ...params.hotelFilter,
          industryType: state.commentParams.industryType,
        }
      }
      if (params.feedbackStatus && params.feedbackStatus.length > 0) {
        params.feedbackStatus = params.feedbackStatus.filter(it => it)
        params.qualityStatus = params.feedbackStatus.map(item => Number(item))
        delete params.feedbackStatus
      }
      if (params.travelPurpose) {
        params.travelPurposes = params.travelPurpose
        delete params.travelPurpose
      }
      if (params.commentArea) {
        let arr = params.commentArea.filter(it => it)
        let newArr = []
        arr.forEach(item => {
          if (item.includes(';')) {
            newArr.push(...item.split(';'))
          } else {
            newArr.push(item)
          }
        })
        params.locales = newArr

        //  params.locales = params.commentArea
        delete params.commentArea
      }

      const channelMap = await ChannelConfig.getChannelConfigMap()

      commentAnalysisApi.groupDetailQueryCount(params).then(res => {
        let totalNumber = 0

        totalNumber = res
        commit('SET_TOTAL', {
          totalNumber,
        })

        // const totalNumber = await commentAnalysisApi.groupDetailQueryCount(params)

        const { countMap = {} } = totalNumber.data || {}
        let counting = {
          allTotal: countMap?.all || 0,
        }
        if (countMap) {
          const convertChannelMap = {}
          ChannelConfig.allChannelList.map(item => {
            convertChannelMap[item.value] = item.CommentListPageConfig.totalBiKey
          })
          Object.keys(convertChannelMap).map(item => {
            if (countMap[item]) {
              counting[convertChannelMap[item]] = countMap[item]
            }
          })
        }

        commit('SET_COMMENT_RAW_DATA', {
          counting,
          pageTotal: totalNumber?.data?.total || 0,
          channelLoading: false,
        })
      })

      const res = await commentAnalysisApi.groupDetailQuery(params)
      if (res?.data && res?.code === 200) {
        const rowData = res.data.records.map(item => {
          const { extraValues, sentiment, value, hotelChannelInfoList } = item
          const channelImg = ChannelConfig.allChannelList.filter(channel => channel.value === item.extraValues.channel)
          let replyList = []
          if (extraValues.replyContent) {
            replyList = [
              {
                detail: extraValues.replyContent,
                commentDate: extraValues.replyDate,
              },
            ]
          }

          let imgList = []
          if (extraValues.extraInfo && extraValues.extraInfo.picInfoList) {
            for (let i = 0; i < extraValues?.extraInfo?.picInfoList.length; i++) {
              let item = extraValues?.extraInfo?.picInfoList[i]
              const collectType = extraValues?.collectType
              if (collectType === 'ebk') {
                imgList.push(item.picUrl)
              } else if (item.picUrl && !item.picUrl.includes('.mp4')) {
                imgList.push(
                  extraValues.channel === 'ctrip' ? 'https://dimg04.c-ctrip.com/images/' + item.picUrl : item.picUrl
                )
              }
            }
          }

          return {
            rowId: item.rowId,
            alertLevel: extraValues?.alertLevel || '',
            channel: channelMap[extraValues.channel],
            channelImg: channelImg.length > 0 ? channelImg[0].img : '', // 渠道Icon
            commentDate: extraValues.commentDate,
            commentType: extraValues.userCommentType,
            dataCid: extraValues.dataCid,
            createdAt: extraValues?.createdAt,
            updatedAt: extraValues?.updatedAt,
            userCommentBed: extraValues?.userCommentBed, // 房型
            locale: item?.locale, // 点评来源
            startCreatedAt: extraValues?.startCreatedAt,
            extraInfo: extraValues?.extraInfo,
            sentimentValue: extraValues?.sentimentValue,
            sentimentLevel: extraValues?.sentimentLevel,
            endCreatedAt: extraValues?.endCreatedAt,
            collectType: extraValues?.collectType,
            isQuality: String(item.isQuality) ? item.isQuality : 0, // 0-我要反馈  1-反馈记录
            detail: {
              cate: sentiment.type,
              value,
              codes: extraValues.cubeCommentLabelList
                .filter(item => item.labelContent)
                .map((it, i) => {
                  // dynamic indicators
                  Object.values(it.labelMap).map((item, i) => {
                    if (item !== 'null') it[`label_${i + 1}`] = item
                  })

                  // it.label_1 = it.label1
                  // it.label_2 = it.label2
                  // it.label_3 = it.label3
                  it.linkContent = it.labelContent
                  let levelBase64 = btoa(encodeURIComponent(it.labelSentimentLevel))
                  if (levelBase64 === 'JUU2JUFEJUEz') {
                    // btoa(encodeURIComponent('正'))
                    it.cate = 'positive'
                  } else if (levelBase64 === 'JUU0JUI4JUFE') {
                    // btoa(encodeURIComponent('中'))
                    it.cate = 'neutral'
                  } else if (levelBase64 === 'JUU4JUI0JTlG') {
                    // btoa(encodeURIComponent('负'))
                    it.cate = 'bad'
                  }
                  return it
                }),
              chTransText: extraValues.chTransText || '',
            },
            liveDate: extraValues.userLiveDate,
            score: Number(extraValues.commentScore),
            realScore: extraValues.commentScore,
            replyList,
            isReply:
              extraValues?.isReply == 2 || extraValues?.isReply == 0 || extraValues?.isReply == -2
                ? extraValues.isReply
                : replyList.length,
            hotelName: extraValues?.hotelName,
            preConsumer:
              extraValues.channel === 'dianping' && extraValues?.extraInfo?.isPreConsumer === 0 ? $t('d5231e') : '',
            labelPortrait: extraValues.labelPortrait || [],
            detailCommentId: extraValues?.detailCommentId,
            qualityMap: {
              commentId: extraValues?.commentId,
              channel: extraValues.channel,
              hotelId: extraValues.hotelId,
              channelHotelID: hotelChannelInfoList[0]?.channelHotelId,
            },
            extraScore: extraValues.extraScore, // 携程、艺龙、飞猪
            featureList: extraValues?.featureList,
            cubeCommentLabelList: extraValues?.cubeCommentLabelList,
            // 是否带图
            imageList: imgList,
            isCoding: extraValues.isCoding, // 0:不展示标签  1:展示标签
            notScoredReason: extraValues?.notScoredReason, // EBK不计分

            valid: extraValues.valid,
            notValidReason: extraValues.notValidReason || '',
          }
        })

        commit('SET_COMMENT_RAW_DATA', {
          rowData: rowData,
          // counting,
          // pageTotal: totalNumber.data.total,
          sentencesHighlight,
          loading: false,
        })

        // dispatch('getIsQuality', rowData)
      }
      if (res?.code === 400) {
        commit('SET_COMMENT_RAW_DATA', {
          rowData: [],
        })
        Message.error(res?.msg || res)
      }
    } catch (error) {
      console.error(error)
    }
    commit('SET_COMMENT_RAW_DATA', {
      loading: false,
      channelLoading: false,
    })
  },
  // 查询指标树
  async listCommentLabelsTree({ rootState, state, commit }, payload = {}) {
    try {
      if (state.commentLabelsTree.loading) {
        return
      }

      // 没有酒店不请求
      // if (!state.commentParams?.ctripHotelIds || state.commentParams?.ctripHotelIds?.length === 0) {
      //   commit('SET_COMMENT_LABELS_TREE', {
      //     labelMap: {},
      //     raws: [],
      //   })
      //   Message.warning('没有酒店符合该组合筛选条件')
      //   return
      // }

      // if (!state.commentParams?.channels) {
      //   commit('SET_COMMENT_LABELS_TREE', {
      //     labelMap: {},
      //     raws: [],
      //   })
      // }

      commit('SET_COMMENT_LABELS_TREE', {
        loading: true,
      })

      const { startTs, endTs, startUserLiveDate, endUserLiveDate, ctripHotelIds, industryType } = state.commentParams
      let params = {
        startTs,
        endTs,
        startUserLiveDate,
        endUserLiveDate,
        ctripHotelIds,
        hotelFilter: payload.hotelFilter,
      }
      // 指标树-观点类型
      const labelSentimentLevel = state.treeSentimentLevel
      if (labelSentimentLevel) {
        params['labelSentimentLevel'] = labelSentimentLevel
      }
      // 业务类型
      if (industryType) {
        params.hotelFilter = {
          ...params.hotelFilter,
          industryType,
        }
      }

      const res = await commentAnalysisApi.groupDetailTreeQuery(params)
      if (res?.data && res?.code === 200) {
        const data = res.data
        let tt = 0
        for (let i = 0; i < data.raws.length; i++) {
          tt += Number(data.raws[i].total)
        }
        data.raws.unshift({
          labelId: 'label_1',
          labelName: $t('f9b741'),
          labelNameEn: 'All',
          total: tt,
          uniqueId: $t('f9b741'),
        })
        commit('SET_COMMENT_LABELS_TREE', {
          ...data,
          raws: commentTreeFormatter(data.raws),
          selectedTree: !state.commentLabelsTree.selectedTree.length ? [{ label_1: $t('f9b741') }] : [],
        })
      }

      if (res?.code === 400) {
        commit('SET_COMMENT_LABELS_TREE', {
          labelMap: {},
          raws: [],
        })
        Message.error(res?.msg || res)
      }
    } catch (error) {
      console.error(error)
    }
    commit('SET_COMMENT_LABELS_TREE', {
      loading: false,
    })
  },
  // 纠错
  async addErrorCorrection({ rootGetters, state, commit }, payload) {
    try {
      if (state.errorCorrection.loading) {
        return
      }
      commit('SET_ERROR_CORRECTION', {
        loading: true,
      })
      const rowItem = state.errorCorrection.rowDataItem
      const commentDate = dayjs(rowItem.commentDate.replace(/(\+)(\d{2})(\d{2})/, '$1$2:$3')).toDate()
      let source
      ChannelConfig.allChannelList.map(item => {
        if (item.value === rowItem.qualityMap.channel) {
          source = item.configValue
        }
      })

      // const codes = uniqBy(rowItem.detail.codes, n =>
      //   Object.keys(n.labelMap)
      //     .map((value, i) => n.labelMap[`label${i + 1}`])
      //     .join(' /')
      // )

      // const codes = rowItem.detail.codes.map(n => {
      //   n.labelMap = Object.keys(n.labelMap)
      //     .map((value, i) => n.labelMap[`label${i + 1}`])
      //     .reduce((initValue, value, i) => {
      //       initValue[`label${i + 1}`] = value
      //       return initValue
      //     }, {})

      //   return {
      //     ...n,
      //   }
      // })

      const params = {
        commentDate: commentDate.getTime(), // `评论时间`
        content: rowItem.detail.value, // `评论内容`
        dataCid: rowItem.dataCid, // `点评id`
        // errorTypeLabel1: 'xxx', // `1:语义分析问题2:外网已修改分值或内容3:外网已删除/折叠4:其他原因`
        // errorTypeLabel2s: ['xx'], // `二级错误标签  情感有误，标签有误，观点分析遗漏`
        hotelId: rowItem.qualityMap.hotelId, // `酒店id`
        // remark: 'xxx', // `备注说明信息`
        source: source, // `评论来源  1:美团2:携程3:飞猪4:艺龙`
        sentiment: rowItem.sentimentValue,
        sentimentLevel: rowItem.sentimentLevel,
        // labelPortraitList: rowItem.labelPortraitList,
        score: rowItem.score,
        detailCommentId: rowItem.detailCommentId,
        ...payload,
      }
      const res = await CommentListService.qualityCreate(params)
      if (res?.code === 200 && res?.data) {
        Message.success($t('c82fae'))
        return true
      }
      Message.error($t('eb9c9f'))
      return false
    } catch (error) {
      console.error(error)
      Message.error($t('eb9c9f'))
      return false
    } finally {
      commit('SET_ERROR_CORRECTION', {
        loading: false,
      })
    }
  },
  // 撤销反馈记录
  async cancelFeedback({ rootState, state, commit }, payload = {}) {
    try {
      let params = {
        hotelId: payload.hotelId,
        commentId: payload.commentId,
        qualityId: payload.qualityId,
      }
      return await CommentListService.cancelFeedback(params)
    } catch (error) {
      console.error(error)
    }
  },
  // 加载回复状态
  async loadReplyStatus({ rootState, state, commit }, payload = {}) {
    try {
      let params = {
        hotelId: payload,
      }

      const res = await commentAnalysisApi.fetchIsLate(params)
      if (res?.code === 200) {
        const { channelIds } = res.data
        const datas = ChannelConfig.allChannelList
          .filter(item => channelIds.includes(item.configValue))
          .map(item => item.value)
        // .map(item => item.CommentListPageConfig.formSearchValue)

        commit('SET_COMMENT_REPLY_STATUS', datas)
      }
    } catch (error) {
      console.error(error)
    }
  },
  // 加载点评类型-情感/分数
  async loadCommentRuleType({ rootState, state, commit }, payload = {}) {
    try {
      // let params = {
      //   hotelId: payload,
      // }
      const res = await AssessmentIndicatorsService.fetchDetail()
      if (res?.code === 200) {
        if (Number(res?.data?.ruleType) === 2) {
          commit('SET_COMMENT_RULE_MAP', res.data?.scoreSectionConfig || {})
        }
        commit('SET_COMMENT_RULE_TYPE', Number(res?.data?.ruleType) === 1)
      }
    } catch (error) {
      console.error(error)
    }
  },
}

const mutations = {
  SET_MODEL_GLOBAL_FIELD(state, modelGlobalField) {
    // 去重
    const res = new Map()
    state.modelGlobalField = modelGlobalField?.filter(data => !res.has(data.key) && res.set(data.key, 1))
  },
  SET_TREE_SENTIMENT_LEVEL(state, treeSentimentLevel) {
    state.treeSentimentLevel = treeSentimentLevel
  },
  SET_SENTENCES_HIGHLIGHT(state, sentencesHighlight) {
    state.sentencesHighlight = sentencesHighlight
  },
  SET_COMMENT_REPLY_STATUS(state, commentReplyStatus) {
    state.commentReplyStatus = commentReplyStatus
  },
  SET_QUALITY_SHOW_DATA(state, qualityShowData) {
    state.qualityShowData = qualityShowData
  },
  SET_FEEDBACK_RECORD_MAP(state, feedbackRecordDatas) {
    state.feedbackRecordDatas = feedbackRecordDatas
  },
  SET_ERROR_CORRECTION(state, payload) {
    state.errorCorrection = {
      ...state.errorCorrection,
      ...payload,
    }
  },
  SET_COMMENT_DATA_TYPE(state, commentDataType) {
    state.commentDataType = commentDataType
  },
  SET_COMMENT_RAW_DATA(state, payload) {
    state.commentRawData = {
      ...state.commentRawData,
      ...payload,
    }
  },
  SET_TOTAL(state, payload) {
    state.totalNumber = payload.totalNumber
  },
  SET_COMMENT_LABELS_FILTER(state, commentLabelsFilter) {
    state.commentLabelsFilter = commentLabelsFilter
  },
  SET_COMMENT_PARAMS(state, payload) {
    let params = { ...state.commentParams, ...payload }
    Object.keys(params).forEach(value => {
      if ([undefined, ''].includes(params[value])) delete params[value]
    })
    state.commentParams = params
  },
  SET_COMMENT_LABELS_TREE(state, payload) {
    state.commentLabelsTree = {
      ...state.commentLabelsTree,
      ...payload,
    }
  },
  SET_INDUSTRY(state, industry) {
    state.industry = industry
  },
  SET_DATA_SOURCE_GROUP_TYPE(state, dataSourceGroupType) {
    state.dataSourceGroupType = dataSourceGroupType
  },
  SET_ANALYSIS_DIMS(state, setAnalysisDims) {
    state.setAnalysisDims = setAnalysisDims
  },
  SET_ALIAS_CONFIG(state, aliasConfig) {
    state.aliasConfig = aliasConfig
  },
  SET_FIELD_DETAIL(state, fieldDetail) {
    state.fieldDetail = fieldDetail
  },
  SET_HOTELCEM_DETAIL(state, hotelcemDetail) {
    state.hotelcemDetail = hotelcemDetail
  },
  SET_TENANTINFO(state, tenantInfo) {
    state.tenantInfo = tenantInfo
  },
  SET_SOURCE_COLUMNS(state, saveSourceColumns) {
    state.saveSourceColumns = saveSourceColumns
  },
  SET_DIMENSION_DATA(state, saveDimensionData) {
    state.saveDimensionData = saveDimensionData
  },
  SET_FIELD_SELECTED_DATA(state, fieldSelectedData) {
    state.fieldSelectedData = fieldSelectedData
  },
  SET_FIELD_SELECTED_DIMENSION_DATA(state, fieldSelectedDimensionData) {
    state.fieldSelectedDimensionData = fieldSelectedDimensionData
  },
  SET_WINDOW_INNER_WIDTH(state, payload) {
    state.windowInnerWidth = payload
  },
  setIsChangeRules(state, isChangeRules) {
    state.isChangeRules = isChangeRules
  },
  setModelRulesDefaultData(state, modelRulesDefaultData) {
    state.modelRulesDefaultData = modelRulesDefaultData
  },
  setDataModelTemplateId(state, dataModelTemplateId) {
    state.dataModelTemplateId = dataModelTemplateId
  },
  setWarnSaveVedioField(state, warnSaveVedioField) {
    state.warnSaveVedioField = warnSaveVedioField
  },
  setIndicatorsLabels(state, indicatorsLabels) {
    state.indicatorsLabels = indicatorsLabels
  },
  setRecordTitle(state, recordTitle) {
    state.recordTitle = recordTitle
  },
  setTextRecord(state, textRecord) {
    state.textRecord = textRecord
  },
  setWarnRecordFilter(state, warnRecordFilter) {
    state.warnRecordFilter = warnRecordFilter
  },
  setWarnRecordInput(state, warnRecordInput) {
    state.warnRecordInput = warnRecordInput
  },
  setWarnRuleTaskSave(state, warnRuleTaskSave) {
    state.warnRuleTaskSave = warnRuleTaskSave
  },
  setUpgradeSave(state, upgradeSave) {
    state.upgradeSave = upgradeSave
  },
  setUpgradeList(state, upgradeList) {
    state.upgradeList = upgradeList
  },
  setRulessTopConditions(state, rulessTopConditions) {
    state.rulessTopConditions = rulessTopConditions
  },
  setWarnRulesSaveData(state, warnRulesSaveData) {
    state.warnRulesSaveData = warnRulesSaveData
  },
  setIsFieldSourceId(state, isFieldSourceId) {
    state.isFieldSourceId = isFieldSourceId
  },
  setWarningDetailData(state, warningDetailData) {
    state.warningDetailData = warningDetailData
  },
  setRulesStatus(state, rulesStatus) {
    state.rulesStatus = rulesStatus
  },
  setChangeType(state, changeType) {
    state.changeType = changeType
  },
  setKeywordList(state, keywordPopList) {
    state.keywordPopList = keywordPopList
  },
  setTextAnalysisParams(state, textAnalysisParams) {
    state.textAnalysisParams = textAnalysisParams
  },
  setSaveData(state, saveData) {
    state.saveData = saveData
  },
  setDataSourceId(state, dataSourceId) {
    state.dataSourceId = dataSourceId
  },
  setIsOpen(state, isOpen) {
    state.isOpen = isOpen
  },
  setDefaultWidth(state, defaultWidth) {
    state.defaultWidth = defaultWidth
  },
  setIsSourcePanel(state, isSourcePanel) {
    state.isSourcePanel = isSourcePanel
  },
  setDataSourceParams(state, params) {
    let columnList = [],
      columnValue = ''
    switch (params.type) {
      case 'dynamicDim':
        state.dataSourceParams.dynamicFieldOptionId = params.fieldId
        break
      case 'isOrderField':
        if (!state.dataSourceParams.chartConfig.customChartConfig)
          state.dataSourceParams.chartConfig.customChartConfig = {}
        state.dataSourceParams.chartConfig.customChartConfig['isOrderField'] = params.sortings
        break
      case 'orderList':
        state.dataSourceParams.orderList = Array.isArray(params.orderList) ? params.orderList : [params.orderList]
        break
      case 'columnConfigList':
        if (params.isRemove) {
          state.dataSourceParams.columnConfigList[params.fieldIndex].splice(params.currentDragIndex, 1)
        } else if (params.isAdd) {
          state.dataSourceParams.columnConfigList[params.currentDragIndex] = params.columnConfigList
        } else if (params.isCalculate) {
          if (params.isUpdate) {
            state.dataSourceParams.columnConfigList[params.currentDragIndex][params.columnIndex].calculate =
              params.calculate
            return
          }
          state.dataSourceParams.columnConfigList[params.currentDragIndex].calculate = params.calculate
        } else if (params.sort) {
          state.dataSourceParams.columnConfigList[params.currentIndex][params.index] = params.list
          return
        } else if (params.isAlias) {
          state.dataSourceParams.columnConfigList[params.currentDragIndex] = params.list
          return
        } else {
          state.dataSourceParams.columnConfigList = params.columnConfigList
        }
        break
      case 'filterList':
        columnList = state.dataSourceParams.columnConfigList[Object.keys(params.fieldIndex)[0]]
        columnValue = Object.values(params.fieldIndex)[0].index
        if (params.isHaSave) {
          columnList = params.filterList
          return
        }
        columnList[columnValue].filterList = Array.isArray(columnList) ? params.filterList : [params.filterList]
        break
      case 'chartConfig':
        if (params.supportReferenceLine) {
          state.dataSourceParams.chartConfig.referenceLineList = params.referenceLineList.filter(
            item => item.axisValue.value
          )
          return
        } else if (params.isEnableQuadrant) {
          state.dataSourceParams.chartConfig.quadrantList = params.quadrantList
          state.dataSourceParams.chartConfig.isEnableQuadrant = params.quadrant
          return
        }
        // 保存模型规则数据
        else if (params.rules) {
          state.dataSourceParams.chartConfig.tableConfig = params.list
          return
        }
        // 保存显示数值数据
        else if (params.chartNumberConfig) {
          if (!state.dataSourceParams.chartConfig.customChartConfig)
            state.dataSourceParams.chartConfig.customChartConfig = {}
          state.dataSourceParams.chartConfig.customChartConfig['chartNumberConfig'] = params.chartNumberConfig
          return
        }
        // 保存xy轴数据
        if (params.scatterConfig) {
          if (!state.dataSourceParams.chartConfig.customChartConfig)
            state.dataSourceParams.chartConfig.customChartConfig = {}
          state.dataSourceParams.chartConfig.customChartConfig['scatterConfig'] = {
            originConfig: params.scatterConfig,
          }
          return
        }
        state.dataSourceParams.chartConfig = params.chartConfig
        break
      case 'name':
        state.dataSourceParams.name = params.name
        break
      case 'dataCustomModelId':
        state.dataSourceParams.dataCustomModelId = params.dataCustomModelId
        break
      case 'industryClassifyList':
        state.dataSourceParams.industryClassifyList = params.industryClassifyList
        break
      case 'internalFilterList':
        state.dataSourceParams.internalFilterList = params.internalFilterList
        break
      default:
        state.dataSourceParams.isEnableDrillDown = params.isEnableDrillDown
        break
    }
  },
  setSourcePanel(state, sourcePanel) {
    state.sourcePanel = sourcePanel
  },
  setCreateSourceData(state, createSourceData) {
    state.createSourceData = createSourceData
  },
  setDirection(state, direction) {
    state.direction = direction
  },
  setExcelToken(state, excelToken) {
    state.excelToken = excelToken
  },
  setStepsList(state, stepsList) {
    state.stepsList = stepsList
  },
  setMoreTableUid(state, moreTableUid) {
    state.moreTableUid = moreTableUid
    sessionStorage.setItem('moreTableUid', JSON.stringify(moreTableUid))
  },
  SET_COMMENT_RULE_TYPE(state, commentRuleType) {
    state.commentRuleType = commentRuleType
  },
  SET_COMMENT_RULE_MAP(state, commentRuleMap) {
    state.commentRuleMap = commentRuleMap
  },
  setHideChildMenu(state, hideChildMenu) {
    state.hideChildMenu = hideChildMenu
  },
  setFrequency(state, frequency) {
    state.frequency = frequency
  },
  setBindWechat(state, isBind) {
    state.isBindWechat = isBind
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
